import { CaptionText, P1 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { Translation } from 'react-i18next';

export const getLegStregthsL = (rootTeamMember) => {
  if (
    rootTeamMember?.rightLegTotalVolume > rootTeamMember?.leftLegTotalVolume
  ) {
    return [
      <Translation ns='myTeam' key='1'>
        {(t) => (
          <P1 inline color={color.colors.secondary100}>
            ({t('weaker')})
          </P1>
        )}
      </Translation>,
      <Translation ns='myTeam' key='2'>
        {(t) => (
          <P1 inline color={color.colors.neutral900}>
            ({t('strong')})
          </P1>
        )}
      </Translation>
    ];
  }

  if (rootTeamMember?.rightLegTotalVolume < rootTeamMember?.leftLegTotalVolume)
    return [
      <Translation ns='myTeam' key='1'>
        {(t) => (
          <P1 inline color={color.colors.neutral900}>
            ({t('strong')})
          </P1>
        )}
      </Translation>,

      <Translation ns='myTeam' key='2'>
        {(t) => (
          <P1 inline color={color.colors.secondary100}>
            ({t('weaker')})
          </P1>
        )}
      </Translation>
    ];

  return ['', ''];
};

export const getLegStregthsS = (rootTeamMember) => {
  if (rootTeamMember?.rightLegTotalVolume > rootTeamMember?.leftLegTotalVolume)
    return [
      <Translation ns='myTeam' key='1'>
        {(t) => (
          <CaptionText center color={color.colors.secondary900}>
            ({t('weaker')})
          </CaptionText>
        )}
      </Translation>,
      <Translation ns='myTeam' key='2'>
        {(t) => (
          <CaptionText center color={color.colors.neutral400}>
            ({t('strong')})
          </CaptionText>
        )}
      </Translation>
    ];

  if (rootTeamMember?.rightLegTotalVolume < rootTeamMember?.leftLegTotalVolume)
    return [
      <Translation ns='myTeam' key='1'>
        {(t) => <h2 style={{ color: '#b5a8a8' }}>({t('strong')})</h2>}
      </Translation>,
      <Translation ns='myTeam' key='2'>
        {(t) => <h2 className='textGradient'>({t('weaker')})</h2>}
      </Translation>
    ];

  return ['', ''];
};

export const getIsLegsWeaker = (rootTeamMember) => {
  if (rootTeamMember?.rightLegTotalVolume < rootTeamMember?.leftLegTotalVolume)
    return [false, true];

  if (rootTeamMember?.rightLegTotalVolume > rootTeamMember?.leftLegTotalVolume)
    return [true, false];

  return [false, false];
};
